
import { groupListCreate, groupSingle, groupUpdate, openModal, closeModal } from '../../../../../redux/actions/action-creator';
import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import Form from '../../../../../components/Form/Form';
import MasterListFooter from '../../../../../components/Footer/Master_Footer/MasterListFooter';
import DropdownNotApplicable from '../../../../../components/Dropdown/DropdownNotApplicable';


const GroupView = ({ data_to_view, title, closeModal_sec }) => {
  const dispatch = useDispatch();

  const [load, setLoad] = useState(false)
  // get redux state -----------------------------------------------------
  const group_all_list = useSelector(state => state.common.group_all_list);
  const { userData = null } = useSelector(state => state.auth);
  const modal_state = useSelector(state => state.common.modal_state);
  const str = '\u2666';
  const initialState = {
    company_id: userData?.id,
    name: '',
    alise_name: '',
    under_id: 'Capital Account',
    under: '5',
    nature_of_group: 'Liabilities',
    group_behaves_like_sub_ledger: 'No',
    nett_debit_credit_balance_for_reporting: 'No',
    used_for_calculation: 'No',
    method_to_allocate_when_used_in_purchase_invoice: `${str} Not Applicable`,
    id: data_to_view?.id
    // status:'Yes'
  }
  const [data, setData] = useState(initialState);

  useEffect(() => {
    setLoad(true);
    dispatch(groupSingle(data_to_view?.id)).then((response) => {
      if (response?.status) {
        setData({
          name: response.data.name,
          alise_name: response.data.alise_name,
          under_id: response.data.under_name,
          under: response.data.under,
          nature_of_group: response.data.nature_of_group,
          group_behaves_like_sub_ledger: response.data.group_behaves_like_sub_ledger,
          nett_debit_credit_balance_for_reporting: response.data.nett_debit_credit_balance_for_reporting,
          used_for_calculation: response.data.used_for_calculation,
          method_to_allocate_when_used_in_purchase_invoice: response.data.method_to_allocate_when_used_in_purchase_invoice,
          company_id: userData?.id,
          id: data_to_view?.id
        })
        setLoad(false)

      }
      else {
        toast.warn(response?.message || 'Fail !', {
          position: toast.POSITION.TOP_CENTER
        });
      }
    }).catch(error => {
      toast.error(error?.message || ' Failed!', {
        position: toast.POSITION.TOP_CENTER
      });
    })
  }, [])
  return (
    <Form
      title='Group View'
      loading={load}
      col='col-7'
      Footer={MasterListFooter}
    >
      <div className='row p-0 ps-2 m-0 mb-1'>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start"
        >
          Group Name
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center"
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start fw-bold`}
        >
          {data?.name}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start"
        >
          Group Alise
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center"
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start fw-bold`}
        >
          {data?.alise}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start"
        >
          Under
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center"
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start fw-bold`}
        >
          {data?.under_id}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start"
        >
          Nature of Group
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center"
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start fw-bold`}
        >
          {data?.nature_of_group}
        </div>
      </div>
    </Form>
  )
}
export default React.memo(GroupView);